module.exports = __webpack_public_path__ + "img/iconfinder_map-marker_299087.71c80642.png";